module.exports = __webpack_public_path__ + "img/bot-48.e8f6d307.jpg";